/**
 * System Stats API
 * Fetches RAM and Disk usage from the backend.
 */

import { apiRequest } from './client.js';

/**
 * Fetch system stats (RAM + Disk usage).
 * @returns {Promise<{ram_total, ram_used, ram_available, disk_total, disk_used, disk_available}>}
 */
export async function getSysStats() {
    return apiRequest('/api/sys/stats');
}
